import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class Answer extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "fieldId", Model.attribute('fieldId'));
    _defineProperty(this, "field", computed('fieldId', fieldId => app.store.getById('masquerade-fields', fieldId)));
    _defineProperty(this, "userId", Model.attribute('user_id'));
  }
}
flarum.reg.add('fof-masquerade', 'lib/models/Answer', Answer);